import Box from '@mui/material/Box'
import styled from '@emotion/styled'
import { cond, get } from 'lodash-es'

const InfoBlock = styled(Box)`
  ${({ theme, $error, $radius, $orderHint, $bgColor, $borderColor }) => `
    background-color: ${cond([
      [(conditions) => conditions.$error, () => theme.palette.secondary.bg],
      [(props) => !!props.$bgColor, () => get(theme.palette, $bgColor)],
      [() => true, () => theme.palette.primary.bgPlus1],
    ])({ $error, $bgColor })};
    border-radius: ${$radius ?? 4}px;
    border: ${cond([
      [(props) => props.$error, () => '1px solid #FFCAB9'],
      [(props) => props.$orderHint, () => '1px solid #C3DB92'],
      [
        (props) => !!props.$borderColor,
        () => `1px solid ${get(theme.palette, $borderColor)}`,
      ],
    ])({ $error, $orderHint, $borderColor })};
  `}
`

export default InfoBlock
